import { render, staticRenderFns } from "./import.vue?vue&type=template&id=189ecfcc&scoped=true"
import script from "./import.vue?vue&type=script&lang=ts"
export * from "./import.vue?vue&type=script&lang=ts"
import style0 from "./import.vue?vue&type=style&index=0&id=189ecfcc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ecfcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189ecfcc')) {
      api.createRecord('189ecfcc', component.options)
    } else {
      api.reload('189ecfcc', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=189ecfcc&scoped=true", function () {
      api.rerender('189ecfcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policies/import.vue"
export default component.exports